import React from 'react'
import { Col, Container, Row, Table } from 'reactstrap'

const FeatureComparison = () => {
  return (
    <Container className="text-center">
      <Row className="margin-top">
        <Col className="text-center" xs="12">
          <Table size="sm" hover>
            <thead className="header-medium">
              <tr>
                <th className="text-left">Feature</th>
                <th>Business Edition</th>
                <th>Team Edition</th>
                <th>Personal Edition</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className="text-left text-medium">Identify Priorities</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Plan Strategies</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Set Goals</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Journal Progress</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Report Accomplishments</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Open API</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Invite Team Members</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Plan Team Strategies</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Communicate Progress (comments)</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Discuss with Team (mentions)</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Follow Progress (subscriptions)</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Setup Unlimited Teams</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Invite Team Leads</td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">Setup / Track Metrics <i>(coming soon)</i></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>

              <tr>
                <td className="text-left text-medium">External Tool Integrations <i>(coming soon)</i></td>
                <td><i className="color-green fas fa-check" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
                <td><i className="color-red fas fa-xmark" /></td>
              </tr>
            </tbody>

          </Table>
        </Col>
      </Row>
    </Container>
  )
}

export default FeatureComparison
